import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

function SectionHead({ kicker, title, sub }) {
  return (
    <header className="section-head">
      <div className="sh-row">
        <span className="sh-rule" />
        <span className="sh-kicker">{kicker}</span>
      </div>
      <h2 className="sh-title">{title}</h2>
      {sub && <p className="sh-sub">{sub}</p>}
    </header>
  );
}

const EMAIL = "support@0v.network";

function Contact() {
  const { t } = useLanguage();

  return (
    <section id="contact" className="section section-contact">
      <SectionHead kicker={t('contact.kicker')} title={t('contact.title')} sub={t('contact.subtitle')} />
      <div className="contact-card">
        <div className="cc-left">
          <div className="cc-asciibox" aria-hidden="true">
            <pre>{`+----------------------+
|                      |
|   .--------------.   |
|   |\\            /|   |
|   | \\          / |   |
|   |  '--------'  |   |
|   '--------------'   |
|                      |
|   E - M A I L        |
|  support@0v.network  |
|                      |
+----------------------+`}</pre>
          </div>
        </div>
        <div className="cc-right">
          <div className="cc-handle cc-handle-email">
            <span className="cc-name">support</span>
            <span className="cc-at">@0v.network</span>
          </div>
          <div className="cc-url">mailto:{EMAIL}</div>
          <p className="cc-desc">
            {t('contact.desc2')}
          </p>
          <div className="cc-actions">
            <a className="btn btn-primary" href={`mailto:${EMAIL}`}>
              <span className="btn-glyph">✉</span> {t('contact.cta.email')}
              <span className="btn-meta">{EMAIL}</span>
            </a>
            <button
              className="btn btn-ghost"
              // Rejects in a sandboxed iframe; swallow so it isn't an unhandled rejection.
              onClick={() => { navigator.clipboard?.writeText(EMAIL).catch(() => {}); }}
            >
              {t('contact.cta.copy')} <span className="arr">⧉</span>
            </button>
          </div>
          <div className="cc-meta">
            <div><span className="hm-k">topic</span><span className="hm-v">opening · billing · ops</span></div>
            <div><span className="hm-k">backup</span><span className="hm-v">{t('contact.meta.backup')}</span></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
